// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a1923684","234":"63fc9c81","354":"31332fe3","453":"47c6949f","580":"995db218","716":"9a579630"}[chunkId] + ".chunk.js";
};